export type WalletPinCodePopupResolves = {
  pinCode: null | string;
};

export enum PinCodeAction {
  VERIFY = 'VERIFY',
  SET = 'SET',
  SET_CONFIRM = 'SET_CONFIRM',
}
